import React, { useEffect, useState } from 'react';
import styles from './Components.module.scss';
import { Modal, LoaderOn, openNotification } from 'tt-ui-lib/core';
import { fetchCommentsReactions, fetchPostReactions } from '../../../api/posts/endpoints/posts';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { allowedReactions } from '../../../constants/addPost';
import { useNavigate } from 'react-router';
import { removeDuplicatesFromArray } from '../../../utils/dataUtils';

const ReactionsModal = ({ isOpen, setIsOpen, id, isPost = false }) => {
  const navigate = useNavigate();

  const [reactions, setReactions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState([]);
  const [filter, setFilter] = useState('all');

  const fetchReactionsData = () => {
    setIsLoading(true);
    const handler = isPost ? fetchPostReactions : fetchCommentsReactions;

    handler(id)
      .then((response) => {
        if (response.status === 200 && response.data) {
          setFilter('all');
          setReactions(response.data);

          const newFilters = [];
          const parsedFilters = removeDuplicatesFromArray(response.data, 'emoji_id');

          parsedFilters.forEach((item) => {
            newFilters.push(item.emoji_id);
          });

          setFilters(newFilters);
        }
      })
      .catch(() => {
        openNotification({
          message: 'Error while loading reactions, try again later',
          type: 'error',
        });
        setIsOpen(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (isOpen) {
      fetchReactionsData();
    } else {
      setFilter('all');
      setFilters([]);
      setReactions([]);
    }
  }, [isOpen]);

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      title="Reactions"
      onClick={(event) => event.stopPropagation()}
    >
      <div className={styles.modalBody}>
        {isLoading ? (
          <div className={styles.reactionsModalContainer}>
            <LoaderOn />
          </div>
        ) : (
          <div className={styles.reactionsModalContainer}>
            <div className={styles.reactionsModalTabs}>
              <Tabs value={filter} onChange={(e, value) => setFilter(value)}>
                <Tab label="All" value="all" />

                {filters.map((filterItem) => (
                  <Tab
                    label={allowedReactions.find((i) => i.id === filterItem)?.icon}
                    value={filterItem}
                  />
                ))}
              </Tabs>
            </div>
            <div className={styles.reactionsList}>
              {reactions
                .filter((reactionItem) =>
                  filter === 'all' ? true : reactionItem.emoji_id === filter
                )
                .map((reactionItem) => (
                  <div className={styles.reactionsModalReactionItem}>
                    <div
                      className={styles.reactionsListUserRow}
                      onClick={() => {
                        navigate(`/dashboard/profile/${reactionItem.user?.id}`);
                      }}
                    >
                      <img
                        src={reactionItem.user?.avatar}
                        alt=""
                        className={styles.reactionsListAvatar}
                      />
                      <div>
                        <div className={styles.reactionsListUserName}>
                          {reactionItem.user?.first_name} {reactionItem.user?.last_name}
                        </div>
                      </div>
                    </div>
                    <div>{allowedReactions.find((i) => i.id === reactionItem.emoji_id)?.icon}</div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ReactionsModal;
